export const mockData = [
    {
        analysisTransactionTypeId: 5,
        transactionName: 'AchPaymentCredits',
        description: 'Per Item (Credit)',
        sortOrder: 0,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 6,
        transactionName: 'AchPaymentDebits',
        description: 'Per Item (Debit)',
        sortOrder: 1,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 7,
        transactionName: 'SameDayAchPaymentCredits',
        description: 'Per Item (Credit) - Same Day',
        sortOrder: 2,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 8,
        transactionName: 'SameDayAchPaymentDebits',
        description: 'Per Item (Debit) - Same Day',
        sortOrder: 3,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 13,
        transactionName: 'BatchesInitiated',
        description: 'Batches Initiated',
        sortOrder: 4,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 14,
        transactionName: 'NachaFileUploaded',
        description: 'NACHA File Uploaded',
        sortOrder: 5,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 1,
            categoryName: 'ACH',
            sortOrder: 0,
        },
    },
    {
        analysisTransactionTypeId: 1,
        transactionName: 'DomesticWirePayment',
        description: 'Domestic',
        sortOrder: 0,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 2,
            categoryName: 'Wire',
            sortOrder: 1,
        },
    },
    {
        analysisTransactionTypeId: 2,
        transactionName: 'InternationalWirePayment',
        description: 'International (USD)',
        sortOrder: 1,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 2,
            categoryName: 'Wire',
            sortOrder: 1,
        },
    },
    {
        analysisTransactionTypeId: 3,
        transactionName: 'DliWirePayment',
        description: 'International (FX)',
        sortOrder: 2,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 2,
            categoryName: 'Wire',
            sortOrder: 1,
        },
    },
    {
        analysisTransactionTypeId: 15,
        transactionName: 'BulkWireFileUploaded',
        description: 'File Uploaded and File Transmitted',
        sortOrder: 3,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 2,
            categoryName: 'Wire',
            sortOrder: 1,
        },
    },
    {
        analysisTransactionTypeId: 4,
        transactionName: 'InternalTransfer',
        description: 'Per Item',
        sortOrder: 0,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 3,
            categoryName: 'Transfer',
            sortOrder: 2,
        },
    },
    {
        analysisTransactionTypeId: 12,
        transactionName: 'ACHExceptions',
        description: 'Decisioned Item (ACH)',
        sortOrder: 0,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 4,
            categoryName: 'Positive Pay',
            sortOrder: 3,
        },
    },
    {
        analysisTransactionTypeId: 11,
        transactionName: 'CheckExceptions',
        description: 'Decisioned Item (Check)',
        sortOrder: 1,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 4,
            categoryName: 'Positive Pay',
            sortOrder: 3,
        },
    },
    {
        analysisTransactionTypeId: 10,
        transactionName: 'PosPayIssued',
        description: 'Per Item (Manually Entered/Uploaded) – Check',
        sortOrder: 2,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 4,
            categoryName: 'Positive Pay',
            sortOrder: 3,
        },
    },
    {
        analysisTransactionTypeId: 9,
        transactionName: 'StopPayment',
        description: 'Per Item',
        sortOrder: 0,
        analysisTransactionTypeCategory: {
            analysisTransactionTypeCategoryId: 5,
            categoryName: 'Stop Payment',
            sortOrder: 4,
        },
    },
];
